import { render, staticRenderFns } from "./SolanJournals.vue?vue&type=template&id=353158ca&scoped=true&"
import script from "./SolanJournals.vue?vue&type=script&lang=ts&"
export * from "./SolanJournals.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "353158ca",
  null
  
)

export default component.exports